module.exports = __webpack_public_path__ + "static/media/instagram.f95029e5.svg";